<template>
  <div class="h-full pb-6">
    <div v-if="!dataAvailable && loaded" class="h-full flex justify-center">
      <p class="self-center px-4 -mt-14 text-center">{{ $t('widget.noDataForPill', {pill: currentLang.toString().toLowerCase()}) }}</p>
    </div>
    <div v-if="dataAvailable && loaded" class="w-full">
      <div class="divide-y divide-gray-300 h-full w-full ">
        <table class="divide-y divide-gray-300 w-full mt-2">
          <thead>
          <tr class="flex flex-row px-4">
            <th class="text-left text-l w-1/2 font-semibold text-gray-900">{{ $t('widget.search.terms.title') }}</th>
            <th class="text-right text-l w-1/2 font-semibold text-gray-900 ">{{ $t('widget.search.terms.value') }}</th>
          </tr>
          </thead>
          <tbody  :class=" hasLongTitle? 'divide-y divide-gray-200 h-28rem flex flex-col overflow-y-auto ': 'divide-y divide-gray-200 flex flex-col overflow-y-auto'+ pillMargin">
            <table-item v-for="item in items"
                        :key="item.id"
                        :name="item.name"
                        :info="item.info"
                        :value="item.value"
                        :hasInfo="hasInfo"
                        :hasScrollBar="items.length > 9"
            ></table-item>
          </tbody>
        </table>
<!--        <div class="text-center px-3 pt-1.5 text-sm flex flex-col justify-end bottom-0">-->
<!--          <a :href="[infoUrl]" class=" moreInfoUrl ">{{ $t('widget.moreInfo') }}</a>-->
<!--        </div>-->
      </div>
    </div>
    <div v-if="dataAvailable && !loaded" class="flex h-full items-center justify-center">
      <div class="loader loader--style3">
        <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 50 50"  xml:space="preserve">
            <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
              <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
              </path>
            </svg>
      </div>
    </div>

  </div>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import TableItem from "@/widgetContent/listItems/TableItem";
import ApiService from "@/services/ApiService";
import {useApiStore} from "@/stores/ApiStore";

let apiService = new ApiService;
const apiDataStore = useApiStore();

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
const emit = defineEmits(["dataLoaded"])

let loaded = ref(false)
let hasInfo = ref(false);
let items = ref([]);
let infoUrl = ref(null);
let url = ref('');
let dataAvailable = ref(true);
let currentEndpoint = ref()
let currentLang = ref();
let pillMargin = ref(" h-[29.75rem] ")
onMounted ( async () => {
  if (props.pills.length <2){
    pillMargin.value = " h-[32.25rem] ";
  }
  props.pills.forEach(el => {
    if (el.selected === true) {
      url.value = el.source
    }
  });
  currentEndpoint.value = url.value
  await getData(currentEndpoint.value)
}
)

watch(() => [props.update, props.source], () => {
  getData(props.source);
})


async function getData(url)
{
  currentLang.value = languageName.of(url.substring(url.lastIndexOf('=')+1));
  items.value = null;
  loaded.value = false;
  let apiData = await apiService.getSearchterms(url);
  emit("dataLoaded")
  items.value = apiData.data.dataSet;
  if (! items.value.length > 0){
    dataAvailable.value = false
  }else {
    dataAvailable.value = true;
    hasInfo.value = apiData.data.hasInfo;
    infoUrl.value = apiData.moreInfoUrl;
  }
  loaded.value = true;
}

const languageName = new Intl.DisplayNames(
    [apiDataStore.getLang], { type: 'language'}
);

</script>
